import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`B.tech 3rd year Computer Science student. Currently participant in GirlScript Summer Of Code.`}</h4>
    <p>{`Previously participated in some Open Source organizations like Student Code-in and PClub Summer Of Code. Passionate about making the native app with Flutter, and open source. Also, have some experience in Data Analysis, machine learning. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      